<script>
	import formBase from '@_system/components/base/form.vue'
	import qualitytestBox from './box/qualitytestgoods.vue'
	export default {
		extends: formBase,
		name: 'qualitytestForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [ 	
				<qualitytest-box ref="qualitytestbox" billCode = {this.billCode} onSubmit = {this.qualitytestboxSubmit} />, 
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {
				supplierwlnid:null,
				billCode:null
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next) {
				formData.supplierwlnid = this.supplierwlnid
				next()
			},
			qualitytestboxSubmit(e){
				if(e.data){
					this.supplierwlnid = e.data.supplierID
					this.fApi.setValue('billID',e.data.billID)
					this.fApi.setValue('detailID',e.data.detailID)
					this.fApi.setValue('storageID',e.data.storageID)
					this.fApi.setValue('storageName',e.data.storageName)
					this.fApi.setValue('goodscode',e.data.skuCode)
					this.fApi.setValue('goodsname',e.data.goodsName)
					this.fApi.setValue('goodsmodel',e.data.skuName)
					this.fApi.setValue('goodssize',e.data.size)
					this.fApi.setValue('supplierwlnid',e.data.supplierwlnid)
					this.fApi.setValue('suppliername',e.data.supplierName)
					this.fApi.setValue('salesManID',e.data.salesManID)
					this.fApi.setValue('salesManName',e.data.salesManName)
					this.fApi.setValue('price',e.data.price)
					this.fApi.setValue('weight',e.data.weight)
					this.fApi.setValue('file_img',window.systemMethods.urltoArr(e.data.pic))
					
				}
				console.log(e)
			},
			goodscodeButton(){
				let billCode = this.fApi.getValue('billCode')
				if(!billCode){
					this.$message.error('未填写【采购单编码】')
					return
				}
				this.billCode = billCode
				this.$nextTick(()=>{
					this.$refs.qualitytestbox.initList()
					this.$refs.qualitytestbox.box.alertBox()
				})
				
			}
			
			
			// beforeInit(next) {
			// 	if (this.extra.billCode && this.extra.goodscode) {
			// 		this.$api.qualitytest.purchaseQuery({
			// 			billCode: this.extra.billCode,
			// 			goodscode: this.extra.goodscode
			// 		}).then(()=>{
			// 			next()
			// 		},()=>{
			// 			this.hide()
			// 			this.back('cancle')
			// 		})					
			// 	} else {
			// 		next()
			// 	}
			// }
		},
		components: {
			qualitytestBox
		}
	}
</script>